// @flow

export const SET_VBMR_AVAILABILITY: 'listo/vbmr/SET_VBMR_AVAILABILITY' = 'listo/vbmr/SET_VBMR_AVAILABILITY';
export const SET_VBMR_LABEL: 'listo/vbmr/SET_VBMR_LABEL' = 'listo/vbmr/SET_VBMR_LABEL';
